import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function Sidebar({ isOpen }) {
  const location = useLocation();
  const navigate = useNavigate();

  // Helper to check if a route is active or starts with a prefix (for submenus)
  const isActive = (path) => location.pathname === path;
  const isActivePrefix = (prefix) => location.pathname.startsWith(prefix);

  // State for submenu open/close (optional: can be improved for UX)
  const [openMenus, setOpenMenus] = useState({});
  const toggleMenu = (menu) => setOpenMenus((prev) => ({ ...prev, [menu]: !prev[menu] }));

  return (
    <div className={`ec-left-sidebar ${isOpen ? 'ec-bg-sidebar' : 'ec-sidebar-fixed'}`}>
      <div id="sidebar" className="sidebar ec-sidebar-footer">
        <div className="ec-brand">
          <a href="#" onClick={e => { e.preventDefault(); navigate('/dashboard'); }} title="Owena">
            <img className="ec-brand-icon" src="assets/img/logo/ec-site-logo.png" alt="" />
            <span className="ec-brand-name text-truncate">Owena</span>
          </a>
        </div>
        <div className="ec-navigation" data-simplebar>
          <ul className="nav sidebar-inner" id="sidebar-menu">
            {/* Dashboard */}
            <li>
              <a
                className={`sidenav-item-link${isActive('/dashboard') ? ' active' : ''}`}
                href="#"
                onClick={e => { e.preventDefault(); navigate('/dashboard'); }}
              >
                <i className="mdi mdi-view-dashboard-outline"></i>
                <span className="nav-text">Dashboard</span>
              </a>
              <hr />
            </li>
            {/* Transactions */}
            <li>
              <a
                className={`sidenav-item-link${isActive('/transactions') ? ' active' : ''}`}
                href="#"
                onClick={e => { e.preventDefault(); navigate('/transactions'); }}
              >
                <i className="mdi mdi-cash-multiple"></i>
                <span className="nav-text">Transactions</span>
              </a>
              <hr />
            </li>
            {/* Orders */}
            <li className="has-sub">
              <a
                className={`sidenav-item-link${isActivePrefix('/orders') || isActive('/refunds') ? ' active' : ''}`}
                href="#"
                onClick={e => { e.preventDefault(); toggleMenu('orders'); }}
              >
                <i className="mdi mdi-cart"></i>
                <span className="nav-text">Orders</span>
                <b className="caret"></b>
              </a>
              <div className={`collapse${openMenus.orders ? ' show' : ''}`}>
                <ul className="sub-menu" id="orders" data-parent="#sidebar-menu">
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/orders') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/orders'); }}
                    >
                      <span className="nav-text">Order Listing</span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/refunds') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/refunds'); }}
                    >
                      <span className="nav-text">Refund Requests</span>
                    </a>
                  </li>
                </ul>
              </div>
              <hr />
            </li>
            {/* Products */}
            <li className="has-sub">
              <a
                className={`sidenav-item-link${isActivePrefix('/products') || isActive('/categories') || isActive('/communities') || isActive('/bulk-product-review') ? ' active' : ''}`}
                href="#"
                onClick={e => { e.preventDefault(); toggleMenu('products'); }}
              >
                <i className="mdi mdi-package-variant"></i>
                <span className="nav-text">Products</span>
                <b className="caret"></b>
              </a>
              <div className={`collapse${openMenus.products ? ' show' : ''}`}>
                <ul className="sub-menu" id="products" data-parent="#sidebar-menu">
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/products') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/products'); }}
                    >
                      <span className="nav-text">Product List</span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/categories') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/categories'); }}
                    >
                      <span className="nav-text">Categories</span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/communities') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/communities'); }}
                    >
                      <span className="nav-text">Communities</span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/bulk-product-review') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/bulk-product-review'); }}
                    >
                      <span className="nav-text">Bulk Product Review</span>
                    </a>
                  </li>
                </ul>
              </div>
              <hr />
            </li>
            {/* Promotions */}
            <li className="has-sub">
              <a
                className={`sidenav-item-link${isActive('/banners') || isActive('/notifications') || isActive('/announcements') ? ' active' : ''}`}
                href="#"
                onClick={e => { e.preventDefault(); toggleMenu('promotions'); }}
              >
                <i className="mdi mdi-bullhorn"></i>
                <span className="nav-text">Promotions</span>
                <b className="caret"></b>
              </a>
              <div className={`collapse${openMenus.promotions ? ' show' : ''}`}>
                <ul className="sub-menu" id="promotions" data-parent="#sidebar-menu">
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/banners') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/banners'); }}
                    >
                      <span className="nav-text">Banners</span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/notifications') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/notifications'); }}
                    >
                      <span className="nav-text">Push Notifications</span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/announcements') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/announcements'); }}
                    >
                      <span className="nav-text">Announcements</span>
                    </a>
                  </li>
                </ul>
              </div>
              <hr />
            </li>
            {/* Help & Support */}
            <li>
              <a
                className={`sidenav-item-link${isActive('/support') ? ' active' : ''}`}
                href="#"
                onClick={e => { e.preventDefault(); navigate('/support'); }}
              >
                <i className="mdi mdi-lifebuoy"></i>
                <span className="nav-text">Help & Support</span>
              </a>
              <hr />
            </li>            
            {/* Reports & Analytics */}
            <li>
              <a
                className={`sidenav-item-link${isActive('/reports') ? ' active' : ''}`}
                href="#"
                onClick={e => { e.preventDefault(); navigate('/reports'); }}
              >
                <i className="mdi mdi-chart-bar"></i>
                <span className="nav-text">Reports & Analytics</span>
              </a>
              <hr />
            </li>
            {/* User Management */}
            <li className="has-sub">
              <a
                className={`sidenav-item-link${isActive('/customers') || isActive('/sellers') || isActive('/subscribers') || isActive('/employees') ? ' active' : ''}`}
                href="#"
                onClick={e => { e.preventDefault(); toggleMenu('users'); }}
              >
                <i className="mdi mdi-account-multiple"></i>
                <span className="nav-text">User Management</span>
                <b className="caret"></b>
              </a>
              <div className={`collapse${openMenus.users ? ' show' : ''}`}>
                <ul className="sub-menu" id="users" data-parent="#sidebar-menu">
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/customers') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/customers'); }}
                    >
                      <span className="nav-text">Customers</span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/sellers') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/sellers'); }}
                    >
                      <span className="nav-text">Sellers</span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/subscribers') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/subscribers'); }}
                    >
                      <span className="nav-text">Subscribers</span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/employees') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/employees'); }}
                    >
                      <span className="nav-text">Employees</span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/permissions') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/permissions'); }}
                    >
                      <span className="nav-text">Permissions</span>
                    </a>
                  </li>
                </ul>
              </div>
              <hr />
            </li>
            {/* Settings */}
            <li className="has-sub">
              <a
                className={`sidenav-item-link${isActive('/settings') || isActive('/activity-logs') ? ' active' : ''}`}
                href="#"
                onClick={e => { e.preventDefault(); toggleMenu('settings'); }}
              >
                <i className="mdi mdi-cog"></i>
                <span className="nav-text">Settings</span>
                <b className="caret"></b>
              </a>
              <div className={`collapse${openMenus.settings ? ' show' : ''}`}>
                <ul className="sub-menu" id="settings" data-parent="#sidebar-menu">
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/settings') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/settings'); }}
                    >
                      <span className="nav-text">Settings</span>
                    </a>
                  </li>
                  <li>
                    <a
                      className={`sidenav-item-link${isActive('/activity-logs') ? ' active' : ''}`}
                      href="#"
                      onClick={e => { e.preventDefault(); navigate('/activity-logs'); }}
                    >
                      <span className="nav-text">Activity Logs</span>
                    </a>
                  </li>
                </ul>
              </div>
              <hr />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
